var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fadeInUp"}},[(_vm.isShow)?_c('div',{staticClass:"absolute",staticStyle:{"z-index":"300"},style:({
      top: _vm.position.bottom + 'px',
      left: _vm.position.left + 'px',
    }),attrs:{"id":"dd-menu-root"}},[(_vm.is_custom)?_c('CustomDDMenu',{attrs:{"custom_cmp":_vm.custom_cmp,"items":_vm.menu},on:{"onAction":_vm.onSubmit}}):_c('DDMenu',{attrs:{"items":_vm.menu},on:{"onAction":_vm.onSubmit}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }